import React from "react";
import SendMail from "../Pages/Mail/SendMail";
import CreateSendsPage from "../Pages/SendsAdmin/CreateSendsPage";
import EditSendsPage from "../Pages/SendsAdmin/EditSendsPage";
import History from "../Pages/SendsAdmin/History";
import Profiles from "../Pages/SendsAdmin/Profiles";
import Users from "../Pages/SendsAdmin/Users";
import SendMailPage from "../Pages/SendMail/SendMailPage";
import UserSendsHistory from "../Pages/SendsUser/UserSendsHistory";
import UserSendsPage from "../Pages/SendsUser/UserSendsPage";
import {SuggestibleRouteInterface} from "./TopRoutes";

const StandaloneSendsUsersRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'SendsAdmin Pages',
        path: '/sends-page',
        element: <UserSendsPage />,
    },
    {
        title: 'SendsAdmin Page',
        path: '/sends-page/:pageId',
        element: <UserSendsPage />
    },
    {
        title: 'SendsAdmin Page History',
        path: '/sends-page/history',
        element: <UserSendsHistory />
    },
]

const StandaloneSendsAdminUsersRoutes : any = [
    {
        title: 'Send Mail',
        path: '/send-mail/send',
        element: <SendMailPage />
    },
    {
        title: 'Sends',
        path: '/send-mail/sends',
        element: <SendMail />
    },
    {
        title: 'SendsAdmin Admin Pages',
        path: '/send-mail/pages',
        element: <Profiles />
    },
    {
        title: 'SendsAdmin Admin History',
        path: '/send-mail/history',
        element: <History />
    },
    {
        title: 'SendsAdmin Admin Users',
        path: '/send-mail/users',
        element: <Users />
    },
    {
        title: 'SendsAdmin Admin Create',
        path: '/send-mail/create',
        element: <CreateSendsPage />
    },
    {
        title: 'SendsAdmin Admin Edit',
        path: '/send-mail/edit/:pageId',
        element: <EditSendsPage />
    },
]

export { StandaloneSendsUsersRoutes, StandaloneSendsAdminUsersRoutes }
